import { combineReducers } from 'redux'

import login from './login'
import licence from './licence'
import club from './club'
import user from './user'

export default combineReducers({
    login,
    licence,
    club,
    user
})
